// Styling som är standard för alla teman
const defaultStyling = {
  gradientRed:
    "linear-gradient(to right bottom, #ff0000, #fc2420, #f83734, #f34745, #ec5454)",
  gradientGreen:
    "linear-gradient(to right bottom, #00ce12, #28da3f, #3fe65d, #53f179, #66fd92)",
  gradientBlue:
    "linear-gradient(to right bottom, #003170, #004f93, #006eb5, #008fd8, #00b2f9)",
  gradientGrey:
    "linear-gradient(to right bottom, #171818, #232728, #2f383a, #3d494d, #4b5a61)",
  gradientLightGrey: "linear-gradient(to right, #868f96 0%, #596164 100%)",
};

const ColorCollection = {
  0: {
    //Gustav
    ...defaultStyling,
    themeColor: "#335cda",
    themeHoverColor: "#143d93",
    themeHoverTextColor: "white",
    themColorDark: "#143d93",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#335cda",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#182d58",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "rgb(39,55,93)",
    tooltipDarkBackgroundColor: "#182d58",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#182d58",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#335cda",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  1: {
    //ABF
    // themeColor: "#AF0009",
    // themeHoverColor: "#d80811",
    // themeHoverTextColor: "white",
    // themColorDark: "#790107",
    // themeHoverDark: "#af0009",
    // themeHoverTextDarkColor: "white",
    // green: "#3fb156",
    // gray: "#818a97",
    // darkGray: "#353c43",
    // red: "#e52b20",
    // blue: "#AF0009",
    // orange: "#ee9412",
    // borderColor: "#ececee",
    // backgroundColor: "#ebeef1",
    // disabledTextColor: "#6F7079",
    // disabledInputColor: "#F3F5F7",
    // disabledBorderColor: "#cbd2dc",
    // blueHoverColor: "#d80811",
    // menuDarkColor: "#a50d1e",
    // menuSeparatorColor: "#f2f0ef",
    // menuMobileSelectedColor: "#A7151D",
    // tooltipDarkBackgroundColor: "#a50d1e",
    // tooltipDarkColor: "white",
    // tooltipLightBackgroundColor: "white",
    // tooltipLightColor: "#a50d1e",
    // messageBadgeColor: "#335cda",
    // actionButtonColor: "#a50d1e",
    // errorColor: "#e52b20",
    // warningColor: "#3fb156",
    ...defaultStyling,
    themeColor: "#335cda",
    themeHoverColor: "#143d93",
    themeHoverTextColor: "white",
    themColorDark: "#143d93",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#335cda",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#182d58",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "rgb(39,55,93)",
    tooltipDarkBackgroundColor: "#182d58",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#182d58",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#335cda",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  2: {
    //Bilda
    ...defaultStyling,
    themeColor: "#351539",
    themeHoverColor: "#412345",
    themeHoverTextColor: "white",
    themColorDark: "#612769",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#351539",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#5F3C64",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "#76547A",
    tooltipDarkBackgroundColor: "#351539",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#351539",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#351539",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  3: {
    //Folkuniveritetet
    themeColor: "#335cda",
    themeHoverColor: "#143d93",
    themeHoverTextColor: "white",
    themColorDark: "#143d93",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#335cda",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#182d58",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "rgb(39,55,93)",
    tooltipDarkBackgroundColor: "#182d58",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#182d58",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#335cda",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  5: {
    //Studiefrämjandet
    ...defaultStyling,
    themeColor: "#990033",
    themeHoverColor: "#FFFFFF",
    themeHoverTextColor: "#990033",
    themColorDark: "#730127",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#990033",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#86122A",
    menuSeparatorColor: "#942c2c",
    menuMobileSelectedColor: "#990033",
    tooltipDarkBackgroundColor: "#990033",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#990033",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#990033",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  7: {
    //Sv
    /* Den gröna färgen som är aktuell för oss har koden: #6BAA24 eller anges i RGB: som 107, 170, 36.
    Och för nyanser;
    Mörkare: #365512 (50 % mörkare)
    Ljusare: #B5D592 (50 % ljusare) 
 */
    ...defaultStyling,
    themeColor: "#6BAA24",
    themeHoverColor: "#B5D592",
    themeHoverTextColor: "white",
    themColorDark: "#365512",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#6baa24",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#365512",
    menuSeparatorColor: "#1F3704",
    menuMobileSelectedColor: "#4D861E",
    tooltipDarkBackgroundColor: "#6BAA24",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#6BAA24",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#365512",
    errorColor: "#ECB4F53",
    warningColor: "#E6B10E",
  },
  8: {
    //NBV
    ...defaultStyling,
    themeColor: "#0f79c8",
    themeHoverColor: "#075DA0",
    themeHoverTextColor: "white",
    themColorDark: "#0b548a",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#0f79c8",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#05487B",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "#085895",
    tooltipDarkBackgroundColor: "#0f79c8",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#0f79c8",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#0f79c8",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  10: {
    //MBS
    ...defaultStyling,
    themeColor: "#217AB7",
    themeHoverColor: "#08609F",
    themeHoverTextColor: "white",
    themColorDark: "#13476b",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#217ab7",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#064A79",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "#095A94",
    tooltipDarkBackgroundColor: "#217AB7",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#217AB78",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#217AB7",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  11: {
    //Sensus
    // themeColor: "#af1432",
    // themeHoverColor: "#90031E",
    // themeHoverTextColor: "white",
    // themColorDark: "#6b0c1f",
    // themeHoverDark: "#af1432",
    // themeHoverTextDarkColor: "white",
    // green: "#3fb156",
    // gray: "#818a97",
    // darkGray: "#353c43",
    // red: "#e52b20",
    // blue: "#335cda",
    // orange: "#ee9412",
    // borderColor: "#ececee",
    // backgroundColor: "#ebeef1",
    // disabledTextColor: "#6F7079",
    // disabledInputColor: "#F3F5F7",
    // disabledBorderColor: "#cbd2dc",
    // blueHoverColor: "#143d93",
    // menuDarkColor: "#690015",
    // menuSeparatorColor: "#0f234e",
    // menuMobileSelectedColor: "#8B152C",
    // tooltipDarkBackgroundColor: "#af1432",
    // tooltipDarkColor: "white",
    // tooltipLightBackgroundColor: "white",
    // tooltipLightColor: "#af1432",
    // messageBadgeColor: "#2087B1",
    // actionButtonColor: "#af1432",
    // errorColor: "#e52b20",
    // warningColor: "#3fb156",
    ...defaultStyling,
    themeColor: "#335cda",
    themeHoverColor: "#143d93",
    themeHoverTextColor: "white",
    themColorDark: "#143d93",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#335cda",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#182d58",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "rgb(39,55,93)",
    tooltipDarkBackgroundColor: "#182d58",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#182d58",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#335cda",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  14: {
    //Ibn Rushd
    ...defaultStyling,
    themeColor: "#96c31e",
    themeHoverColor: "#57A823",
    themeHoverTextColor: "white",
    themColorDark: "#566f12",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#96c31e",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#3D660E",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "#5E8C29",
    tooltipDarkBackgroundColor: "#3D660E",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#3D660E",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#96c31e",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
  15: {
    //Kulturens
    ...defaultStyling,
    themeColor: "#1b1d1f",
    themeHoverColor: "#3E4348",
    themeHoverTextColor: "white",
    themColorDark: "#46494c",
    themeColorExtraDark: "#08183a",
    themeHoverDark: "#1b1d1f",
    themeHoverTextDarkColor: "white",
    green: "#3fb156",
    gray: "#818a97",
    darkGray: "#353c43",
    red: "#e52b20",
    lightRed: "#FCE9E8",
    blue: "#335cda",
    orange: "#ee9412",
    lightOrange: "#fdf4e7",
    borderColor: "#ececee",
    backgroundColor: "#ebeef1",
    disabledTextColor: "#6F7079",
    disabledInputColor: "#F3F5F7",
    disabledBorderColor: "#cbd2dc",
    blueHoverColor: "#143d93",
    menuDarkColor: "#5C6369",
    menuSeparatorColor: "#0f234e",
    menuMobileSelectedColor: "#787D82",
    tooltipDarkBackgroundColor: "#1b1d1f",
    tooltipDarkColor: "white",
    tooltipLightBackgroundColor: "white",
    tooltipLightColor: "#1b1d1f",
    messageBadgeColor: "#d5240a",
    actionButtonColor: "#1b1d1f",
    errorColor: "#e52b20",
    warningColor: "#3fb156",
  },
};
export default ColorCollection;
